<section class="radio-buttons flex-col gap-8" data-testid="select-list">
  @if (value && value?.['answerType'] && value?.['answerType'] !== 'RESPONSE_FIELD') {
    <section class="flex-col gap-12">
      <section class="body selected-value">
        <p>{{ value[this.valueKey()] }}</p>
      </section>
      <section>
        <button type="button" class="change-button" (click)="selectValue(undefined)">
          <i class="fa-light fa-arrow-left"></i>
          <span>Change</span>
        </button>
      </section>
    </section>
  } @else {
    @for (option of vm.options; track option.value; let index = $index) {
      <app-radio-button
        variant="blue"
        [ngModel]="value"
        (ngModelChange)="selectValue($event)"
        [includeResetOption]="false"
        [name]="vm.name"
        [index]="index"
        [optionValue]="option.value"
        data-testid="select-list-option"
      >
        <p class="body radio-text">{{ option.title }}</p>
      </app-radio-button>
    }
  }
</section>
